// extracted by mini-css-extract-plugin
module.exports = {"footerBtm":"footer_footerBtm__3l8wz","desktopFooter":"footer_desktopFooter__2Muw5"};